export default __webpack_public_path__ + "static/media/top_ui_panel.306e5336.png";